import { render, staticRenderFns } from "./WSMechas.vue?vue&type=template&id=481836e3&scoped=true"
import script from "./WSMechas.vue?vue&type=script&lang=js"
export * from "./WSMechas.vue?vue&type=script&lang=js"
import style0 from "./WSMechas.vue?vue&type=style&index=0&id=481836e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481836e3",
  null
  
)

export default component.exports